import {Trans, useTranslation} from 'react-i18next';
import {Calendar, IdCard} from 'lucide-react';
import {FormSection, InfoBox} from '@chekinapp/ui';
import {formatDisplayDate} from '../helpers';

type Props = {
  checkInDate?: string;
};

function IVUnavailableNotice({checkInDate}: Props) {
  const {t, i18n} = useTranslation();
  const formattedCheckIn = formatDisplayDate(checkInDate, i18n.language);

  return (
    <div className="flex w-full max-w-[560px] flex-col gap-4">
      <FormSection>
        <FormSection.Header icon={<Calendar />}>
          {t('outside_check_in_period')}
        </FormSection.Header>
        <FormSection.Body className="flex flex-col gap-3">
          <p className="text-[13.5px] leading-5 text-[var(--chekin-color-gray-1)]">
            {formattedCheckIn ? (
              <Trans
                i18nKey="iv_verification_opens_on"
                values={{date: formattedCheckIn}}
                components={{
                  1: (
                    <strong className="font-semibold text-[var(--chekin-color-brand-navy)]" />
                  ),
                }}
              />
            ) : (
              t('iv_only_available_on_check_in_day')
            )}
          </p>
          <p className="text-[13.5px] leading-5 text-[var(--chekin-color-gray-1)]">
            {t('iv_everything_else_can_be_completed')}
          </p>
        </FormSection.Body>
      </FormSection>

      <InfoBox icon={<IdCard />}>
        <Trans i18nKey="iv_be_ready_on_the_day_note" components={{1: <strong />}} />
      </InfoBox>
    </div>
  );
}

export {IVUnavailableNotice};
